import { useContext } from 'react';

import {
  AiBuilderChatActionsContext,
  AiBuilderChatComposerSignalContext,
} from './AiBuilderChatProvider';
export {
  useAiBuilderChatComposerSelector,
  useAiBuilderChatIsGeneratingSelector,
  useAiBuilderChatMessagesSelector,
  useAiBuilderChatPanelSelector,
  useAiBuilderChatSessionIdSafe,
  useAiBuilderChatStore,
  useAiBuilderChatStoreAtomValue,
} from './aiBuilderChatStore.selectors';

const createMissingProviderError = (hookName: string) =>
  `${hookName} must be used within AiBuilderChatProvider`;

export const useAiBuilderChatComposerSignalState = () => {
  const state = useContext(AiBuilderChatComposerSignalContext);

  if (!state) {
    throw new Error(
      createMissingProviderError('useAiBuilderChatComposerSignalState'),
    );
  }

  return state;
};

export const useAiBuilderChatActions = () => {
  const actions = useContext(AiBuilderChatActionsContext);

  if (!actions) {
    throw new Error(createMissingProviderError('useAiBuilderChatActions'));
  }

  return actions;
};
